module.exports = __webpack_public_path__ + "static/media/login.0a37ec6d.svg";